import { theme } from "../../../theme";
const {
  colors: {
    transparent,
    white,
    greyscale,
    neutral,
    violet
  }
} = theme;
export const buttonColors = {
  primary: 'primary',
  secondary: 'secondary',
  alwaysWhite: 'always-white',
  disabled: 'disabled'
};
export const buttonHeights = {
  32: 32,
  44: 44,
  52: 52,
  72: 72
};
export const buttonPaddings = {
  32: '0 8px',
  44: '0 10px',
  52: '0 14px',
  72: '0 24px'
};
export const textPaddings = {
  32: '0 4px',
  44: '0 8px',
  52: '0 8px',
  72: '0 8px'
};
export const buttonRadiuses = {
  32: '12px',
  44: '16px',
  52: '16px',
  72: '20px'
};
export const textSizes = {
  32: 'c2',
  44: 'c1',
  52: 'c1',
  72: 'p4'
};
export const fontSizes = {
  32: '10px',
  44: '12px',
  52: '12px',
  72: '14px'
};
export const lineHeights = {
  32: '12px',
  44: '16px',
  52: '16px',
  72: '20px'
};
export const buttonActiveScale = {
  32: 0.9375,
  44: 0.9545,
  52: 0.9615,
  72: 0.9722
};
export const buttonColorsConfig = {
  [buttonColors.primary]: {
    background: violet.primary,
    text: white,
    hover: `linear-gradient(rgba(188, 195, 208, 0.4),rgba(188, 195, 208, 0.4)) ${violet.primary}`
  },
  [buttonColors.secondary]: {
    background: neutral.g700,
    text: greyscale.g800,
    hover: `linear-gradient(rgba(188, 195, 208, 0.25),rgba(188, 195, 208, 0.25)) ${neutral.g700}`
  },
  [buttonColors.alwaysWhite]: {
    background: white,
    text: greyscale.g800,
    hover: `linear-gradient(rgba(188, 195, 208, 0.4),rgba(188, 195, 208, 0.4)) ${white}`
  },
  [buttonColors.disabled]: {
    background: 'rgba(188, 195, 208, 0.5)',
    text: neutral.g400,
    hover: transparent
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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